import type { BaseComparisonTableColumn } from '@ria-client/supergraph/review/schema/types';
import { ReviewComparisonTable } from '../reviews/review-comparison-table';
import type { NodeProps } from '../types';

export function FinancialAdvisorsComparisonTable({
  props,
}: NodeProps<{ columns?: BaseComparisonTableColumn[]; heading?: string }>) {
  if (!props?.columns) return null;

  return (
    <ReviewComparisonTable
      comparisonTable={{ columns: props.columns, heading: props.heading ?? '' }}
    />
  );
}
